import ResolveError from "./ResolveError.mjs";
/**
 * @public
 */
class ResolverError extends ResolveError {}
export default ResolverError;